var map = {
	"./01_btu.jpg": "7f27",
	"./02_dife.jpg": "ade2",
	"./03_fgw.jpg": "be60",
	"./04_fh.jpg": "0ee6",
	"./05_hpi.jpg": "eecc",
	"./06_ihp.jpg": "0988",
	"./07_mhb.jpg": "a562",
	"./08_mpi.jpg": "e735",
	"./08_mpi_2.jpg": "1427",
	"./09_rki.jpg": "5c07",
	"./10_thiem.jpg": "dec4",
	"./11_thwi.jpg": "3fdf",
	"./12_up.jpg": "91cf",
	"./13_fh-iap.jpg": "f399",
	"./14_hereon.jpg": "538d",
	"./15_hmu.jpg": "22fe",
	"./15_hmu_2.jpg": "d446",
	"./16_harding.jpg": "2cef",
	"./17_evb-potsdam.jpg": "265a",
	"./bha-map.svg": "5bca",
	"./bhs_brandenburg_health_sciences.png": "ca63",
	"./brandenburg.jpg": "ef75",
	"./brandenburg_2.jpg": "bba8",
	"./brandenburg_3.png": "03e3",
	"./default.jpg": "8ca2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e1ab";